'use strict';

var cov_116vzweyh3 = function () {
  var path = '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/ClientIntlProvider/lib/index.js',
      hash = '7ea363043d1fb72e1d749ce1a6ca300284066a8d',
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: '/codebuild/output/src396452290/src/apps/tnwi/temp/helpers/ClientIntlProvider/lib/index.js',
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ClientIntlProvider = require('./ClientIntlProvider');

var _ClientIntlProvider2 = _interopRequireDefault(_ClientIntlProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ClientIntlProvider2.default;